import http from './httpService';
import {t, getLanguage} from "react-switch-lang";
import axios from 'axios';
import {BASE_URL, token} from '../utils/const';


const nameValue = getLanguage() === "eng" ? "nameEn" : "name";

export function getAlldepartments() {
  return http.get(`/departments?sort=${nameValue}`);
}
export const getAllDepartments = (pageNumber = 0, size = 20, appModuleIds = [], query= '') => {
  const moduleParam =
    appModuleIds?.length === 1
      ? `&appModuleId.equals=${appModuleIds[0]}`
      : appModuleIds?.length > 1
        ? `&appModuleId.in=${appModuleIds.join(',')}`
        : '';
  return axios({
    method: 'GET',
    url: `${BASE_URL}/departments?page=${pageNumber}&size=${size}&sort=${nameValue}${moduleParam}${query ? `&search.contains=${query}` : ''}`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  });
};

export function updatedepartment(payload) {
  return http.put('/departments', payload);
}

export function createdepartment(payload) {
  return http.post('/departments', payload);
}

export function deletedepartment(id) {
  return http.delete(`/departments/${id}`);
}
export function getAllDepartmentTypes() {
  return http.get(`/department-types?sort=${nameValue}`);
}
export function getAllResponsibleUsers() {
  return http.get(`/users/all-responsible-users?sort=firstName`);
}
export function getAllUsers() {
  return http.get(`/users`);
}

export function getAllUsersCount(size) {
  return http.get(`/users?page=0&size=${size}`);
}

export function countUsers() {
  return http.get(`/users/count`);
}

export function deactivateDepartment(departmentId) {
  return http.put(`/departments/${departmentId}/toggle-activation`);
}